import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getCityList } from '@utils/cities';
import AlertShape from '@alerts/shapes/alert';

import AlertModal from './AlertModal';

class AlertModalWrapper extends Component {
  static propTypes = {
    alert: PropTypes.shape(AlertShape),
    cities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        currencyIsoCode: PropTypes.string
      })
    ).isRequired,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired
  };

  static defaultProps = {
    alert: undefined
  };

  state = {
    isLoading: false
  };

  cities = getCityList(this.props.cities);
  cityNames = Object.keys(this.cities).map(city => this.cities[city].name);

  confirm = async alertData => {
    this.setState({
      isLoading: true
    });
    try {
      await this.props.onConfirm(alertData);
      this.setState({
        isLoading: false
      });
    } catch (error) {
      console.error(error);
      this.setState({
        isLoading: false
      });
    }
  };

  render() {
    return (
      <AlertModal
        isOpen={this.props.isModalOpen}
        cancel={this.props.onClose}
        confirm={this.confirm}
        cities={this.cities}
        cityNames={this.cityNames}
        alert={this.props.alert}
        isLoading={this.state.isLoading}
      />
    );
  }
}

export default AlertModalWrapper;
